var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"MF_eZtnHPjvqMbJy_keTw"};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/admin";

import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN: string =
  "https://71775be18eea4bef9aa654da6a6a937a@o1287378.ingest.sentry.io/6503946";

Sentry.init({
  dsn: SENTRY_DSN,
  environment: process.env.REPO_ENV,
  release: require("package.json").version,
  tracesSampleRate: 1.0
});
